import { render, staticRenderFns } from "./Karriere.vue?vue&type=template&id=0ca54f15&scoped=true&"
import script from "./Karriere.vue?vue&type=script&lang=js&"
export * from "./Karriere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca54f15",
  null
  
)

export default component.exports